/* eslint-disable import/prefer-default-export */
import axios from '../../axios';

// ---------------------------------------------------------------------------
// RH / Recrutamento & Seleção — Dependentes do candidato (service layer,
// handoff 0065 §4, Fase 1).
//
// Aninhados ao candidato. Criar/editar/excluir REGENERA o checklist de
// documentos no backend (docs por filho conforme a idade) — quem chama deve
// recarregar dependentes E documentos juntos. `age` é derivada (read-only).
// Opcionais vazios são OMITIDOS no payload (padrão F0 — o Zod rejeita null
// em create). Permissões: hr:candidate_dependent:read|manage.
// ---------------------------------------------------------------------------

export async function listDependents(candidateId) {
   const response = await axios.get(
      `/hr/recruitment/candidates/${candidateId}/dependents`,
   );
   return response?.data?.data?.dependents ?? [];
}

// payload: { full_name (obrigatório), birth_date? (YYYY-MM-DD), cpf?,
// relationship? (FILHO·FILHA·OUTRO) }
export async function createDependent(candidateId, payload = {}) {
   const body = { full_name: payload.full_name };
   if (payload.birth_date) body.birth_date = payload.birth_date;
   if (payload.cpf) body.cpf = payload.cpf;
   if (payload.relationship) body.relationship = payload.relationship;

   const response = await axios.post(
      `/hr/recruitment/candidates/${candidateId}/dependents`,
      body,
   );
   return {
      dependent: response?.data?.data?.dependent ?? null,
      message: response?.data?.message ?? 'Dependente cadastrado.',
   };
}

export async function updateDependent(candidateId, dependentId, payload = {}) {
   const body = {};
   ['full_name', 'birth_date', 'cpf', 'relationship'].forEach((key) => {
      if (key in payload) body[key] = payload[key];
   });

   const response = await axios.put(
      `/hr/recruitment/candidates/${candidateId}/dependents/${dependentId}`,
      body,
   );
   return {
      dependent: response?.data?.data?.dependent ?? null,
      message: response?.data?.message ?? 'Dependente atualizado.',
   };
}

// Backend responde 204 sem body (barra com 422 se o dependente já tem
// documento coletado no checklist).
export async function deleteDependent(candidateId, dependentId) {
   await axios.delete(
      `/hr/recruitment/candidates/${candidateId}/dependents/${dependentId}`,
   );
}
